import { useEffect, useState } from "react";
import { apiRedes, armarTexto } from "./MarketingRedes";
const API = "/api";
const token = () => localStorage.getItem("token");

export default function Productos() {
  const [productos, setProductos] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState({nombre:"",descripcion:"",precio:"",precio_oferta:"",categoria_id:"",destacado:false,activo:true,disponible:true,orden:0});
  const [fotos, setFotos] = useState<File[]>([]);
  const [previews, setPreviews] = useState<string[]>([]);
  const [imagenesExistentes, setImagenesExistentes] = useState<any[]>([]);
  const [videosExistentes, setVideosExistentes] = useState<any[]>([]);
  const [videosNuevos, setVideosNuevos] = useState<File[]>([]);
  const [toast, setToast] = useState("");
  // Publicar en redes sociales (Marketing > Redes sociales)
  const [rsCfg, setRsCfg] = useState<any>(null);
  const [rsConectadas, setRsConectadas] = useState<string[]>([]);
  const [rsPublicar, setRsPublicar] = useState(false);
  const [rsRedes, setRsRedes] = useState<string[]>([]);
  const [rsTexto, setRsTexto] = useState<string | null>(null);
  useEffect(() => {
    apiRedes("/config").then(setRsCfg).catch(() => {});
    apiRedes("/cuentas").then((c: any) => setRsConectadas(["facebook", "instagram"].filter(r => c?.[r]))).catch(() => {});
  }, []);
  const prepararRedes = (nuevo: boolean) => {
    const redes = (rsCfg?.redes || []).filter((r: string) => rsConectadas.includes(r));
    setRsRedes(redes); setRsTexto(null);
    setRsPublicar(nuevo && !!rsCfg?.auto_publicar && redes.length > 0);
  };

  const mostrarToast = (msg:string) => { setToast(msg); setTimeout(()=>setToast(""),3000); };
  const cargar = () => {
    fetch(API + "/productos/").then(r=>r.json()).then(d=>Array.isArray(d)&&setProductos(d)).catch(()=>{});
    fetch(API + "/categorias/").then(r=>r.json()).then(d=>Array.isArray(d)&&setCategorias(d)).catch(()=>{});
  };
  useEffect(()=>{cargar();},[]);

  const abrirNuevo = () => {
    setEditando(null);
    setForm({nombre:"",descripcion:"",precio:"",precio_oferta:"",categoria_id:"",destacado:false,activo:true,disponible:true,orden:0});
    setFotos([]); setPreviews([]); setImagenesExistentes([]); setVideosExistentes([]); setVideosNuevos([]);
    prepararRedes(true);
    setModal(true);
  };

  const abrirEditar = async (p:any) => {
    setEditando(p);
    setForm({nombre:p.nombre,descripcion:p.descripcion||"",precio:p.precio||"",precio_oferta:p.precio_oferta||"",categoria_id:p.categoria_id||"",destacado:p.destacado,activo:p.activo,disponible:p.disponible!==false,orden:p.orden||0});
    setFotos([]); setPreviews([]);
    const r = await fetch(API + "/productos/" + p.id + "/imagenes");
    const imgs = await r.json();
    setImagenesExistentes(Array.isArray(imgs) ? imgs : []);
    const rv = await fetch(API + "/productos/" + p.id + "/videos");
    const vids = await rv.json();
    setVideosExistentes(Array.isArray(vids) ? vids : []);
    setVideosNuevos([]);
    prepararRedes(false);
    setModal(true);
  };

  const seleccionarFotos = (e:any) => {
    const files = Array.from(e.target.files) as File[];
    setFotos(prev => [...prev, ...files]);
    setPreviews(prev => [...prev, ...files.map((f:any) => URL.createObjectURL(f))]);
  };

  const quitarNueva = (i:number) => {
    setFotos(prev => prev.filter((_,idx)=>idx!==i));
    setPreviews(prev => prev.filter((_,idx)=>idx!==i));
  };

  const eliminarExistente = async (imgId:number) => {
    await fetch(API + "/productos/" + editando.id + "/imagenes/" + imgId, {method:"DELETE",headers:{Authorization:"Bearer " + token()}});
    setImagenesExistentes(prev => prev.filter(img=>img.id!==imgId));
    mostrarToast("Imagen eliminada");
  };

  const guardar = async () => {
    const h = {"Content-Type":"application/json",Authorization:"Bearer " + token()};
    const body = {...form,precio:Number(form.precio),precio_oferta:form.precio_oferta?Number(form.precio_oferta):null,categoria_id:form.categoria_id?Number(form.categoria_id):null,orden:Number(form.orden)};
    const url = editando ? API + "/productos/" + editando.id : API + "/productos/";
    const r = await fetch(url,{method:editando?"PUT":"POST",headers:h,body:JSON.stringify(body)});
    const data = await r.json();
    const pid = data.id || editando?.id;
    if (fotos.length > 0 && pid) {
      const fd = new FormData();
      fotos.forEach(f => fd.append("files", f));
      await fetch(API + "/productos/" + pid + "/imagenes",{method:"POST",headers:{Authorization:"Bearer " + token()},body:fd});
    }
    if (videosNuevos.length > 0 && pid) {
      const fv = new FormData();
      videosNuevos.forEach(v => fv.append("files", v));
      await fetch(API + "/productos/" + pid + "/videos",{method:"POST",headers:{Authorization:"Bearer " + token()},body:fv});
    }
    let avisoRedes = "";
    if (rsPublicar && pid && rsRedes.length) {
      if (fotos.length === 0 && imagenesExistentes.length === 0) avisoRedes = " · no se publicó en redes: falta una foto";
      else {
        try { await apiRedes(`/publicar/${pid}`, { method: "POST", body: { redes: rsRedes, texto: rsTexto ?? textoRedes() } }); avisoRedes = " · publicando en redes 📣"; }
        catch (e: any) { avisoRedes = " · redes: " + e.message; }
      }
    }
    cargar(); setModal(false); mostrarToast((editando?"Producto actualizado":"Producto creado") + avisoRedes);
  };

  const textoRedes = () => armarTexto(rsCfg?.plantilla || "{nombre}\n{precio}\n\n{descripcion}", {
    nombre: form.nombre, precio: form.precio, precio_oferta: form.precio_oferta, descripcion: form.descripcion,
    categoria: categorias.find((c:any) => String(c.id) === String(form.categoria_id))?.nombre || "",
  });

  const eliminar = async (id:number) => {
    await fetch(API + "/productos/" + id,{method:"DELETE",headers:{Authorization:"Bearer " + token()}});
    cargar(); mostrarToast("Producto eliminado");
  };

  const imgUrl = (url:string) => url.startsWith("http") ? url : "https://importacionesby.com" + url;

  return (
    <div>
      {toast && <div style={{position:"fixed",top:"24px",right:"24px",zIndex:50,background:"#fff",border:"1px solid #e5e7eb",boxShadow:"0 4px 20px rgba(0,0,0,0.1)",borderRadius:"12px",padding:"12px 20px",fontWeight:700,fontSize:"14px"}}>{toast}</div>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"24px"}}>
        <h1 style={{fontFamily:"Montserrat,sans-serif",fontSize:"24px",fontWeight:900,color:"#1a1a2e"}}>Productos ({productos.length})</h1>
        <button onClick={abrirNuevo} style={{background:"#1565C0",color:"#fff",border:"none",padding:"10px 20px",borderRadius:"12px",fontWeight:700,fontSize:"14px",cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>+ Agregar</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:"16px"}}>
        {productos.map(p => (
          <div key={p.id} style={{background:"#fff",borderRadius:"16px",overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
            <div style={{height:"160px",background:"#f3f4f6",display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden"}}>
              {p.imagen_url ? <img src={imgUrl(p.imagen_url)} alt={p.nombre} style={{width:"100%",height:"100%",objectFit:"cover"}}/> : <span style={{fontSize:"40px"}}>📦</span>}
            </div>
            <div style={{padding:"16px"}}>
              <div style={{fontWeight:800,fontSize:"14px",marginBottom:"4px"}}>{p.nombre}</div>
              <div style={{fontFamily:"Montserrat,sans-serif",fontSize:"18px",fontWeight:900,color:"#1565C0",marginBottom:"12px"}}>₡{p.precio?.toLocaleString()}</div>
              <div style={{display:"flex",gap:"8px"}}>
                <button onClick={()=>abrirEditar(p)} style={{flex:1,background:"#EFF6FF",color:"#1565C0",border:"none",padding:"8px",borderRadius:"8px",fontWeight:700,fontSize:"12px",cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>Editar</button>
                <button onClick={()=>eliminar(p.id)} style={{background:"#fef2f2",color:"#ef4444",border:"none",padding:"8px 12px",borderRadius:"8px",fontWeight:700,fontSize:"12px",cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>🗑️</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:40,display:"flex",alignItems:"center",justifyContent:"center",padding:"24px"}}>
          <div style={{background:"#fff",borderRadius:"20px",width:"100%",maxWidth:"520px",maxHeight:"90vh",overflow:"auto"}}>
            <div style={{padding:"20px 24px",borderBottom:"1px solid #f3f4f6",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <h2 style={{fontFamily:"Montserrat,sans-serif",fontWeight:900,fontSize:"18px",color:"#1565C0"}}>{editando?"Editar":"Nuevo"} Producto</h2>
              <button onClick={()=>setModal(false)} style={{background:"none",border:"none",fontSize:"20px",cursor:"pointer"}}>X</button>
            </div>
            <div style={{padding:"24px",display:"flex",flexDirection:"column",gap:"16px"}}>
              {["nombre","descripcion","precio","precio_oferta"].map(field => (
                <div key={field}>
                  <label style={{fontSize:"12px",fontWeight:700,color:"#6b7280",textTransform:"uppercase",letterSpacing:"1px",display:"block",marginBottom:"6px"}}>{field}</label>
                  <input value={(form as any)[field]} onChange={e=>setForm({...form,[field]:e.target.value})}
                    style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"10px",padding:"10px 14px",fontSize:"14px",outline:"none",fontFamily:"Nunito,sans-serif",boxSizing:"border-box"}}/>
                </div>
              ))}
              <div>
                <label style={{fontSize:"12px",fontWeight:700,color:"#6b7280",textTransform:"uppercase",letterSpacing:"1px",display:"block",marginBottom:"6px"}}>Categoria</label>
                <select value={form.categoria_id} onChange={e=>setForm({...form,categoria_id:e.target.value})}
                  style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"10px",padding:"10px 14px",fontSize:"14px",outline:"none",fontFamily:"Nunito,sans-serif"}}>
                  <option value="">Sin categoria</option>
                  {categorias.map(c=><option key={c.id} value={c.id}>{c.nombre}</option>)}
                </select>
              </div>
              <div style={{display:"flex",gap:"16px"}}>
                <label style={{display:"flex",alignItems:"center",gap:"8px",cursor:"pointer",fontWeight:600,fontSize:"14px"}}>
                  <input type="checkbox" checked={form.destacado} onChange={e=>setForm({...form,destacado:e.target.checked})}/> Destacado
                </label>
                <label style={{display:"flex",alignItems:"center",gap:"8px",cursor:"pointer",fontWeight:600,fontSize:"14px"}}>
                  <input type="checkbox" checked={form.activo} onChange={e=>setForm({...form,activo:e.target.checked})}/> Activo
                </label>
                <label style={{display:"flex",alignItems:"center",gap:"8px",cursor:"pointer",fontWeight:600,fontSize:"14px"}}>
                  <input type="checkbox" checked={form.disponible} onChange={e=>setForm({...form,disponible:e.target.checked})}/> Disponible
                </label>
              </div>

              <div>
                <label style={{fontSize:"12px",fontWeight:700,color:"#6b7280",textTransform:"uppercase",letterSpacing:"1px",display:"block",marginBottom:"8px"}}>Imagenes</label>
                {imagenesExistentes.length > 0 && (
                  <div style={{marginBottom:"12px"}}>
                    <div style={{fontSize:"12px",color:"#6b7280",marginBottom:"6px",fontWeight:600}}>Imagenes actuales:</div>
                    <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
                      {imagenesExistentes.map(img => (
                        <div key={img.id} style={{position:"relative",width:"80px",height:"80px"}}>
                          <img src={imgUrl(img.imagen_url)} alt="" style={{width:"80px",height:"80px",objectFit:"cover",borderRadius:"8px",border:"2px solid #e5e7eb"}}/>
                          <button onClick={()=>eliminarExistente(img.id)}
                            style={{position:"absolute",top:"-6px",right:"-6px",background:"#ef4444",color:"#fff",border:"none",borderRadius:"50%",width:"20px",height:"20px",cursor:"pointer",fontSize:"11px",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center"}}>
                            X
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {previews.length > 0 && (
                  <div style={{marginBottom:"12px"}}>
                    <div style={{fontSize:"12px",color:"#6b7280",marginBottom:"6px",fontWeight:600}}>Nuevas imagenes:</div>
                    <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
                      {previews.map((src,i) => (
                        <div key={i} style={{position:"relative",width:"80px",height:"80px"}}>
                          <img src={src} alt="" style={{width:"80px",height:"80px",objectFit:"cover",borderRadius:"8px",border:"2px solid #1565C0"}}/>
                          <button onClick={()=>quitarNueva(i)}
                            style={{position:"absolute",top:"-6px",right:"-6px",background:"#ef4444",color:"#fff",border:"none",borderRadius:"50%",width:"20px",height:"20px",cursor:"pointer",fontSize:"11px",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center"}}>
                            X
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <label style={{display:"block",border:"2px dashed #e5e7eb",borderRadius:"12px",padding:"16px",textAlign:"center",cursor:"pointer"}}>
                  <div style={{fontSize:"24px",marginBottom:"4px"}}>📸</div>
                  <div style={{fontSize:"13px",color:"#6b7280",fontWeight:600}}>Clic para agregar imagenes</div>
                  <div style={{fontSize:"11px",color:"#9ca3af",marginTop:"2px"}}>Puedes seleccionar varias a la vez</div>
                  <input type="file" accept="image/*" multiple onChange={seleccionarFotos} style={{display:"none"}}/>
                </label>
              </div>

              <div>
                <label style={{fontSize:"12px",fontWeight:700,color:"#374151",textTransform:"uppercase",letterSpacing:"1px",display:"block",marginBottom:"8px"}}>Videos</label>
                {videosExistentes.length > 0 && (
                  <div style={{marginBottom:"12px"}}>
                    <div style={{fontSize:"12px",color:"#6b7280",marginBottom:"6px",fontWeight:600}}>Videos actuales:</div>
                    <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
                      {videosExistentes.map((v:any) => (
                        <div key={v.id} style={{position:"relative",width:"100px",height:"70px",background:"#000",borderRadius:"8px",overflow:"hidden",display:"flex",alignItems:"center",justifyContent:"center"}}>
                          <span style={{fontSize:"28px"}}>🎬</span>
                          <button onClick={async()=>{ await fetch(API+"/productos/"+editando.id+"/videos/"+v.id,{method:"DELETE",headers:{Authorization:"Bearer "+token()}}); setVideosExistentes(prev=>prev.filter((x:any)=>x.id!==v.id)); }}
                            style={{position:"absolute",top:"-6px",right:"-6px",background:"#ef4444",color:"#fff",border:"none",borderRadius:"50%",width:"20px",height:"20px",cursor:"pointer",fontSize:"11px",fontWeight:700}}>X</button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {videosNuevos.length > 0 && (
                  <div style={{marginBottom:"12px"}}>
                    <div style={{fontSize:"12px",color:"#6b7280",marginBottom:"6px",fontWeight:600}}>Nuevos videos ({videosNuevos.length}):</div>
                    <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
                      {videosNuevos.map((_:any,i:number) => (
                        <div key={i} style={{position:"relative",width:"100px",height:"70px",background:"#1e293b",borderRadius:"8px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                          <span style={{fontSize:"28px"}}>🎥</span>
                          <button onClick={()=>setVideosNuevos(prev=>prev.filter((_:any,idx:number)=>idx!==i))}
                            style={{position:"absolute",top:"-6px",right:"-6px",background:"#ef4444",color:"#fff",border:"none",borderRadius:"50%",width:"20px",height:"20px",cursor:"pointer",fontSize:"11px",fontWeight:700}}>X</button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <label style={{display:"block",border:"2px dashed #e5e7eb",borderRadius:"12px",padding:"16px",textAlign:"center",cursor:"pointer"}}>
                  <div style={{fontSize:"24px",marginBottom:"4px"}}>🎬</div>
                  <div style={{fontSize:"13px",color:"#6b7280",fontWeight:600}}>Clic para agregar videos</div>
                  <div style={{fontSize:"11px",color:"#9ca3af",marginTop:"2px"}}>MP4, MOV, WEBM</div>
                  <input type="file" accept="video/*" multiple onChange={e=>{ const files=Array.from(e.target.files||[]) as File[]; setVideosNuevos(prev=>[...prev,...files]); }} style={{display:"none"}}/>
                </label>
              </div>


              {rsConectadas.length > 0 && (
                <div style={{border:"2px solid "+(rsPublicar?"#93c5fd":"#e5e7eb"),borderRadius:"12px",padding:"14px",background:rsPublicar?"#EFF6FF":"#fff"}}>
                  <label style={{display:"flex",alignItems:"center",gap:"8px",cursor:"pointer",fontWeight:800,fontSize:"14px"}}>
                    <input type="checkbox" checked={rsPublicar} onChange={e=>setRsPublicar(e.target.checked)}/> 📣 Publicar en redes sociales al guardar
                  </label>
                  {rsPublicar && (
                    <div style={{marginTop:"10px",display:"grid",gap:"8px"}}>
                      <div style={{display:"flex",gap:"16px",fontSize:"14px"}}>
                        {rsConectadas.map(r => (
                          <label key={r} style={{display:"flex",alignItems:"center",gap:"6px"}}>
                            <input type="checkbox" checked={rsRedes.includes(r)} onChange={e=>setRsRedes(e.target.checked?[...rsRedes,r]:rsRedes.filter(x=>x!==r))}/>{r==="facebook"?"Facebook":"Instagram"}
                          </label>))}
                      </div>
                      <textarea value={rsTexto ?? textoRedes()} onChange={e=>setRsTexto(e.target.value)}
                        style={{width:"100%",minHeight:"110px",border:"2px solid #e5e7eb",borderRadius:"10px",padding:"10px 12px",fontSize:"13px",fontFamily:"Nunito,sans-serif",boxSizing:"border-box",resize:"vertical"}}/>
                      <div style={{fontSize:"12px",color:"#6b7280"}}>Se publica con las fotos del producto (si hay varias, como carrusel).{rsTexto!==null && <> · <span onClick={()=>setRsTexto(null)} style={{color:"#1565C0",cursor:"pointer",fontWeight:700}}>volver al texto automático</span></>}</div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div style={{padding:"16px 24px",borderTop:"1px solid #f3f4f6",display:"flex",gap:"12px",justifyContent:"flex-end"}}>
              <button onClick={()=>setModal(false)} style={{padding:"10px 20px",borderRadius:"10px",border:"1px solid #e5e7eb",fontSize:"14px",fontWeight:600,cursor:"pointer",background:"#fff",fontFamily:"Nunito,sans-serif"}}>Cancelar</button>
              <button onClick={guardar} style={{padding:"10px 20px",borderRadius:"10px",background:"#1565C0",color:"#fff",border:"none",fontSize:"14px",fontWeight:700,cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}